// extracted by mini-css-extract-plugin
export var active = "_h1-7";
export var blink = "_h1-8";
export var dropDownSelector = "_h1-4";
export var dropDownWrapper = "_h1-3";
export var fakeCursor = "_h1-6";
export var fontSizeButton = "_h1-9";
export var formQuillEditor = "_h1-0";
export var pressed = "_h1-a";
export var qlBlank = "_h1-1";
export var textFormattingToolbar = "_h1-2";
export var textToolbarOption = "_h1-5";